export const GET_DRIVER = 'GET_DRIVER';
export const GET_DRIVER_SUCCESS = 'GET_DRIVER_SUCCESS';
export const GET_DRIVER_FAILURE = 'GET_DRIVER_FAILURE';

export const CREATE_DRIVER = 'UPDATE_DRIVER';
export const CREATE_DRIVER_SUCCESS = 'UPDATE_DRIVER_SUCCESS';
export const CREATE_DRIVER_FAILURE = 'UPDATE_DRIVER_FAILURE';

export const UPDATE_DRIVER_PASSWORD = 'UPDATE_DRIVER_PASSWORD';
export const UPDATE_DRIVER_PASSWORD_SUCCESS = 'UPDATE_DRIVER_PASSWORD_SUCCESS';
export const UPDATE_DRIVER_PASSWORD_FAILURE = 'UPDATE_DRIVER_PASSWORD_FAILURE';


export const GET_CALENDAR_USER = 'GET_CALENDAR_USER';
export const GET_CALENDAR_USER_SUCCESS = 'GET_CALENDAR_USER_SUCCESS';
export const GET_CALENDAR_USER_FAILURE = 'GET_CALENDAR_USER_FAILURE';

export const CREATE_CALENDAR_USER = 'CREATE_CALENDAR_USER';
export const CREATE_CALENDAR_USER_SUCCESS = 'CREATE_CALENDAR_USER_SUCCESS';
export const CREATE_CALENDAR_USER_FAILURE = 'CREATE_CALENDAR_USER_FAILURE';

export const UPDATE_CALENDAR_USER_PASSWORD = 'UPDATE_CALENDAR_USER_PASSWORD';
export const UPDATE_CALENDAR_USER_PASSWORD_SUCCESS = 'UPDATE_CALENDAR_USER_PASSWORD_SUCCESS';
export const UPDATE_CALENDAR_USER_PASSWORD_FAILURE = 'UPDATE_CALENDAR_USER_PASSWORD_FAILURE';

export const UPDATE_CALENDAR_ACCESS = 'UPDATE_CALENDAR_ACCESS';
export const UPDATE_CALENDAR_ACCESS_SUCCESS = 'UPDATE_CALENDAR_ACCESS_SUCCESS';
export const UPDATE_CALENDAR_ACCESS_FAILURE = 'UPDATE_CALENDAR_ACCESS_FAILURE';

export const RESET_TRANSPORT_USER = 'RESET_TRANSPORT_USER';


// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/constants/transport_user.constants.js